var _rect, _rect2, _path, _line, _path2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFluid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 70,
    viewBox: "0 0 130 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.7002,
    y: 1,
    width: 68,
    height: 9,
    rx: 0.5,
    transform: "rotate(90 9.7002 1)",
    fill: "#C8D9FF",
    stroke: "#4680FF",
    strokeDasharray: "2 2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 129.299,
    y: 1,
    width: 26,
    height: 108,
    rx: 1.5,
    transform: "rotate(90 129.299 1)",
    fill: "#C8D9FF",
    stroke: "#4680FF",
    strokeDasharray: "2 2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.397 19.28C35.2703 19.28 35.1437 19.2333 35.0437 19.1333L30.697 14.7867C29.9903 14.08 29.9903 12.92 30.697 12.2133L35.0437 7.86668C35.237 7.67335 35.557 7.67335 35.7503 7.86668C35.9437 8.06001 35.9437 8.38001 35.7503 8.57335L31.4037 12.92C31.0837 13.24 31.0837 13.76 31.4037 14.08L35.7503 18.4267C35.9437 18.62 35.9437 18.94 35.7503 19.1333C35.6503 19.2267 35.5237 19.28 35.397 19.28Z",
    fill: "#DC2626"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 112.799,
    y1: 14,
    x2: 38.7988,
    y2: 14,
    stroke: "#DC2626",
    strokeDasharray: "2 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.397 7.71999C117.524 7.71999 117.65 7.76665 117.75 7.86665L122.097 12.2133C122.804 12.92 122.804 14.08 122.097 14.7867L117.75 19.1333C117.557 19.3267 117.237 19.3267 117.044 19.1333C116.85 18.94 116.85 18.62 117.044 18.4267L121.39 14.08C121.71 13.76 121.71 13.24 121.39 12.92L117.044 8.57332C116.85 8.37999 116.85 8.05999 117.044 7.86665C117.144 7.77332 117.27 7.71999 117.397 7.71999Z",
    fill: "#DC2626"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: -0.5,
    width: 11,
    height: 108,
    rx: 0.5,
    transform: "matrix(3.84011e-08 -1 -1 -4.9756e-08 128.199 68.5)",
    fill: "#C8D9FF",
    stroke: "#4680FF",
    strokeDasharray: "2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluid);
export default __webpack_public_path__ + "static/media/fluid.985a42ad782f7e36146d3d7d60701ce3.svg";
export { ForwardRef as ReactComponent };